<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>FTP Account Information</template>
    <template v-slot:body>
      <strong>Connection Settings</strong>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>FTP Username</v-list-item-subtitle>
            <v-list-item-title>
              {{ account.user }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-0"></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>FTP server</v-list-item-subtitle>
            <v-list-item-title>
              <!-- TODO: endpoint? -->
              ftp.{{ hosting.domain }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-0"></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>FTP & explicit FTPS port</v-list-item-subtitle>
            <v-list-item-title>
              {{ ftpPort }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-0"></v-divider>
      </v-list>
    </template>
    <template v-slot:actions>
      <gg-btn primary @click="close">Close</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ConfigureModal',
  mixins: [modalMixin],
  props: {
    account: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {}
  },
  computed: mapGetters({
    ftpPort: 'ftp/ftpPort',
    hosting: 'hosting',
  }),
}
</script>
